import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.2803 2H1.71875L2.99071 7.08782L1.92555 22H14V17H16V22H21.9995V13.382L14.9995 9.88197L12.3683 11.1976L12.0103 7.08014L13.2803 2ZM4.0735 20L4.93065 8H10.0827L10.4444 12.1595L7.99953 13.382V20H4.0735ZM10.7188 4L10.2188 6H4.7803L4.2803 4H10.7188Z"}}]};

const ChimneyFilled = Vue.extend<IconProps>({
  name: 'ChimneyFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'chimney-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ChimneyFilled;
